__turbopack_context__.v({
  "iframe": "CpCustomComponent-module__E0-qKG__iframe",
});
